import { NetworkStateSlice } from "./types";

export const initialState: NetworkStateSlice = {
  network: { isFetching: false },
};
